const colors = [
	"#FFE74C", "#FF5964", "#35A7FF", "#F62DAE", "#00F6ED", "#7D53DE", "#D3F8E2", "#E4C1F9", "#F18805", "#2ecc71",
	"#f1c40f", "#e67e22", "#e74c3c", "#ecf0f1", "#95a5a6", "#f39c12", "#d35400", "#c0392b", "#bdc3c7", "#7f8c8d"
];

const runColors = [
    '#ffc107',
    '#2196F3',
    '#795548',
    '#00bcd4',
    '#607d8b',
    '#4CAF50',
    '#8bc34a',
    '#3f51b5',
    '#cddc39',
    '#ff9800',
    '#ff5722',
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#f44336',
    '#009688',
    '#000',
    '#9e9e9e',
]

export default colors;
export {
	colors, runColors
}